import _ from 'lodash';
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import Money from 'common/components/MoneyDisplay';
import { transactionPropTypes } from 'common/propTypes';
import InstrumentGroupsSentence from 'common/components/InstrumentGroupsSentence';
import LinkToIOStrategy from 'v2/common/components/LinkToIOStrategy/index';
import { RUN_GRANULARITY } from 'v2/common/constants/index';
import ForceExitConfirmation from 'common/components/ForceExitConfirmation/index';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  transaction: transactionPropTypes.isRequired,
  cumulativeProfit: PropTypes.number,
  isNumerousRuns: PropTypes.bool.isRequired,
  isLive: PropTypes.bool.isRequired,
  granularity: PropTypes.string.isRequired,
  isShowCaseSquareOffBtn: PropTypes.bool.isRequired,
  onCaseForceExit: PropTypes.func.isRequired
};
const defaultProps = {
  cumulativeProfit: null
};

const TransactionCollapsed = ({
  transaction, cumulativeProfit, isNumerousRuns, isLive, granularity, isShowCaseSquareOffBtn, onCaseForceExit
}) => {
  const {
    sortId,
    transactionNumber,
    instruments,
    overallProfit,
    isComplete,
    isIlliquidTransaction,
    transactionAndRunId,
    pairedOrders,
    caseIndex,
  } = transaction;
  const shouldShowSecondsInTime = granularity === RUN_GRANULARITY.second || isLive;

  const renderTime = useCallback((isEntry) => {
    let times = _.chain(pairedOrders)
      .map(({ entryTime, exitTime }) => (isEntry ? entryTime : exitTime))
      .compact()
      .uniqBy((t) => t.valueOf())
      .sortBy((t) => t.valueOf())
      .value();

    times = times.map((time) =>
      time?.format(shouldShowSecondsInTime ? 'DD MMM YYYY HH:mm:ss' : 'DD MMM YYYY HH:mm')
    );

    if (_.isEmpty(times)) return <div className="time text-left">-</div>;
    if (times.length === 1) return <div className="time text-left">{_.first(times)}</div>;

    return <div className="time text-left tx-10">{`${_.first(times)} - ${_.last(times)}`}</div>;
  }, [pairedOrders, granularity]);

  return (
    <tr className="collapsed" key={sortId}>
      <td className="align-middle">
        <div className="transaction-number">
          {_.toNumber(caseIndex)+1}
        </div>
      </td>
      <td className="align-middle">
          {!isNumerousRuns ? transactionNumber : transactionAndRunId}
      </td>
      <td className="text-wrap"><InstrumentGroupsSentence instrumentGroups={[instruments]} /></td>
      <td />
      <td colSpan="3" className="entry-wrapper">
        {renderTime(true)}
      </td>
      <td colSpan="3" className="exit-wrapper">
        {renderTime(false)}
      </td>
      <td className="text-right">
        {isComplete && <Money shouldColor>{overallProfit}</Money>}
      </td>
      <td className="align-middle text-success text-right d-flex align-items-center justify-content-end">
        {!isComplete && <div className="incomplete" />}
        {isShowCaseSquareOffBtn && <ForceExitConfirmation
          onForceExit={onCaseForceExit}
          divClassName="square-off-btn"
          iconClassName="material-icons-outlined"
          label="Case Close"
        />}
        {isIlliquidTransaction && <div className="illiquid" />}
        {isComplete && <Money shouldColor>{cumulativeProfit}</Money>}
      </td>
      {!ApplicationDomainUtility.isAlgoverse ? (
        <td className="align-middle">
          <LinkToIOStrategy pairedOrders={pairedOrders} additionalClassNames="ignore-expand-collapse" />
        </td>
      ) : (
        <td />
      )}
    </tr>
  );
};

TransactionCollapsed.propTypes = propTypes;
TransactionCollapsed.defaultProps = defaultProps;
export default TransactionCollapsed;
